module.exports = __webpack_public_path__ + "static/tressym_slobberchops-58a74e0296133523f916c42fa6fe9614.jpeg";